import { isEqual } from 'es-toolkit';
import React, { FunctionComponent, useState } from 'react';
import { useDispatch } from 'react-redux';

import { userService } from '@paragon/data-connections';
import { getLoggedInUser, logIn, UserRoleEditor } from '@paragon/login-tools';
import { enqueueError } from '@paragon/notification-tools';
import { Dialog } from '@paragon/popup-state';

import { UserOrganizationDropdown } from '../controls/UserOrganizationDropdown';
import { useLibrarySelector } from '../hooks';

interface Props {
  onClose: () => void;
}

const PermissionsDevTools: FunctionComponent<Props> = (props) => {
  const dispatch = useDispatch();
  const user = useLibrarySelector(getLoggedInUser)!;

  const [roleSet, setRoleSet] = useState(user.roleSet);

  return (
    <Dialog
      title="Edit roles and permissions for current user"
      onCancel="close"
      onClose={props.onClose}
      submitText="submit"
      onSubmit={async () => {
        if (!isEqual(roleSet, user.roleSet)) {
          try {
            const updatedUser = await userService.users.updateRoleSet(user.email, roleSet);
            updatedUser.token = user.token;

            dispatch(logIn({ user: updatedUser }));
          } catch (err) {
            console.error(err);
            dispatch(enqueueError('Error updating permissions.'));
          }
        }

        props.onClose();
      }}
    >
      <UserOrganizationDropdown user={user} />

      <UserRoleEditor showOtherPermissions value={roleSet} onChange={setRoleSet} />
    </Dialog>
  );
};

export default PermissionsDevTools;
